module.exports = __webpack_public_path__ + "img/ehd.49e013b9.jpg";